import { useState, useEffect } from 'react';
// 🔥 Import statycznej mapy przystanków
import FULL_STOP_MAP from '../data/FULL_STOP_MAP.js';

function useFavorites(stops) {
  const [favoriteStops, setFavoriteStops] = useState(
    (JSON.parse(localStorage.getItem('favoriteStops')) || []).map(id => Number(id))
  );

  const [favoriteStopsData, setFavoriteStopsData] = useState(
    JSON.parse(localStorage.getItem('favoriteStopsData')) || []
  );

  // Funkcja pomocnicza do tworzenia pełnej nazwy przystanku (ZAKTUALIZOWANA LOGIKA MAPOWANIA)
  const getFullStopName = (stop) => {
    const stopIdString = stop.stopId.toString();

    // 1. Sprawdzamy mapowanie dla stopId w statycznym pliku (dla Gdyni i Gdańska)
    const mappedName = FULL_STOP_MAP[stopIdString];

    if (mappedName) {
      // Jeśli nazwa jest w naszej statycznej mapie (np. "Witomino Centrum 01"), używamy jej.
      return mappedName;
    }

    // 2. Logika awaryjna (dla przystanków nieujętych w mapowaniu)
    if (stop.subName) {
      return `${stop.stopDesc} ${stop.subName}`;
    }

    // 3. Ostatecznie używamy głównej nazwy
    return stop.stopDesc;
  };


  // synchronizacja na starcie
  useEffect(() => {
    if (favoriteStopsData.length > 0 && favoriteStops.length === 0) {
      const stopIds = favoriteStopsData.map(stop => stop.stopId);
      setFavoriteStops(stopIds);
      localStorage.setItem('favoriteStops', JSON.stringify(stopIds));
    } else if (favoriteStops.length > 0 && favoriteStopsData.length === 0 && stops.length > 0) {
      const stopsWithData = favoriteStops
        .map(id => stops.find(stop => stop.stopId === id))
        .filter(Boolean)
        .map(stop => ({
          stopId: stop.stopId,
          stopName: stop.stopName || stop.stopDesc,
          stopCode: stop.stopCode,
          stopDesc: stop.stopDesc,
          stopSubName: stop.stopSubName,
          stopLat: stop.stopLat,
          stopLon: stop.stopLon,
          // 🔥 POPRAWIONE MIEJSCE 1: Użycie funkcji getFullStopName
          fullStopName: getFullStopName(stop)
        }));

      setFavoriteStopsData(stopsWithData);
      localStorage.setItem('favoriteStopsData', JSON.stringify(stopsWithData));
    }
  }, [stops, favoriteStops, favoriteStopsData]);

  const toggleFavorite = (e, stopId) => {
    e.preventDefault();
    e.stopPropagation();

    const normalizedId = Number(stopId);

    const stopData = stops.find(stop => Number(stop.stopId) === normalizedId);
    if (!stopData) return;

    const isAlreadyFavorite = favoriteStops.includes(normalizedId);

    let newFavoriteStops;
    let newFavoriteStopsData;

    if (isAlreadyFavorite) {
      newFavoriteStops = favoriteStops.filter(id => id !== normalizedId);
      newFavoriteStopsData = favoriteStopsData.filter(stop => stop.stopId !== normalizedId);
    } else {
      const stopDataToSave = {
        stopId: normalizedId,
        stopName: stopData.stopName || stopData.stopDesc,
        stopCode: stopData.stopCode,
        stopDesc: stopData.stopDesc,
        stopSubName: stopData.stopSubName,
        stopLat: stopData.stopLat,
        stopLon: stopData.stopLon,
        // 🔥 POPRAWIONE MIEJSCE 2: Użycie funkcji getFullStopName
        fullStopName: getFullStopName(stopData)
      };

      newFavoriteStops = [...favoriteStops, normalizedId];
      newFavoriteStopsData = [...favoriteStopsData, stopDataToSave];
    }

    setFavoriteStops(newFavoriteStops);
    setFavoriteStopsData(newFavoriteStopsData);
    localStorage.setItem('favoriteStops', JSON.stringify(newFavoriteStops));
    localStorage.setItem('favoriteStopsData', JSON.stringify(newFavoriteStopsData));
    window.dispatchEvent(new Event('storage'));
  };

  const updateFavoritesOrder = (newFavoritesData) => {
    // newFavoritesData to tablica całych obiektów przystanków w nowej kolejności
    const newFavoriteIds = newFavoritesData.map(stop => stop.stopId);

    setFavoriteStops(newFavoriteIds);
    setFavoriteStopsData(newFavoritesData);

    localStorage.setItem('favoriteStops', JSON.stringify(newFavoriteIds));
    localStorage.setItem('favoriteStopsData', JSON.stringify(newFavoritesData));
    window.dispatchEvent(new Event('storage'));
  };

  return {
    favoriteStops,
    favoriteStopsData,
    toggleFavorite,
    updateFavoritesOrder
  };
}

export default useFavorites;